import type { ReactElement, SVGProps } from "react";

/**
 * Bash's phone page glyphs, the mock's own symbols (mockups/bash-phone-2026-10-14.html):
 * 24-unit stroke paths in InvoicesGlyph's style. Under an account roof the roof sizes and
 * strokes them; anywhere else the caller passes the classes.
 */

export function PhoneGlyph(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path d="M5 3h4l2 5-2.5 1.5a11 11 0 0 0 6 6L16 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 5a2 2 0 0 1 2-2" />
    </svg>
  );
}

export function PeopleGlyph(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
    </svg>
  );
}

export function LockGlyph(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </svg>
  );
}

export function WaveGlyph(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path d="M4 10v4M8 7v10M12 4v16M16 7v10M20 10v4" />
    </svg>
  );
}

export function ClockGlyph(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  );
}

export function CheckMarkGlyph(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path d="m5 12 5 5 9-10" />
    </svg>
  );
}

export function PlusGlyph(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}

/** Who rang whom: out for a call they made, in for one Bash made. */
export function CallOutGlyph(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path d="M7 17 17 7M9 7h8v8" />
    </svg>
  );
}

export function CallInGlyph(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path d="M17 7 7 17M15 17H7V9" />
    </svg>
  );
}

export function PlayGlyph(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg viewBox="0 0 10 10" aria-hidden="true" {...props}>
      <path d="M1.5 0.8v8.4L9 5z" />
    </svg>
  );
}

/** The stroke a glyph wears outside a roof. */
export const GLYPH_STROKE =
  "fill-none stroke-current [stroke-width:2] [stroke-linecap:round] [stroke-linejoin:round]";
